import { render, staticRenderFns } from "./ReceiveCmp.vue?vue&type=template&id=38c2a80c&scoped=true"
import script from "./ReceiveCmp.vue?vue&type=script&lang=js"
export * from "./ReceiveCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2a80c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c2a80c')) {
      api.createRecord('38c2a80c', component.options)
    } else {
      api.reload('38c2a80c', component.options)
    }
    module.hot.accept("./ReceiveCmp.vue?vue&type=template&id=38c2a80c&scoped=true", function () {
      api.rerender('38c2a80c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/serviceOroviderOrder/component/EditCmp/ReceiveCmp.vue"
export default component.exports